export default class SecondaryWalletTypeGeneralSettings {
    overridable: boolean = false;
    enabled: boolean = true;
    code: string = '';
    name: string = '';
    allowedCurrencies: string[] = [];
}